module.exports = __webpack_public_path__ + "static/media/info.514ae4c4.svg";